<template>
    <div :style="{'top' : stickyHeight + 'px'}" :class="['non-sticky-wrapper']"   >
        <div v-if="show" class="swiper-container">
            <div class="swiper-wrapper">
                <no-transition-messages :class="['swiper-slide']" 
                                        v-for="page in pages" 
                                        :stickyHeight="stickyHeight" 
                                        :messages="slideMessages(page)"
                                        :data-swiper-autoplay="slideMessagesDuration(page)"
                                        :full-screen-dnb="fullScreenStretch">

                </no-transition-messages>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Swiper from 'swiper';
    import ResizeMessage from './resize-message';
    import NoTransitionMessages from './no-transition-messages';
    Vue.component('resize-message', ResizeMessage);
    require('swiper/dist/css/swiper.css');

    //Vue.component('swipe-transition-messages', SwipeMessages);
    Vue.component('no-transition-messages', NoTransitionMessages);

    export default {
        data() {
            return {
                swiper: {
                    type: Object
                },
                pages: {
                    type: Number
                },
                show: {
                    type: false
                },
                fullScreenMessage: {
                    type: Boolean,
                    default: false
                }
            }
        },
        methods: {

            slideMessages: function (page) {
                return this.pages == 1 ?
                    this.messages :
                    this.messages.slice(
                        parseInt(Math.ceil(this.messages.length / this.pages) * (page - 1)),
                        parseInt(Math.ceil(this.messages.length / this.pages) * page));
            },
            slideMessagesDuration: function (page) {
                var messages = this.slideMessages(page);
                var defaultTransitionSpeed = this.noticeBoard == null ? 10 : this.noticeBoard.transitionSpeed;

                var slideDuration =  messages.reduce(
                   function (previousValue, message) {
                       return previousValue + (message.transitionSpeedOverride == null ?
                           defaultTransitionSpeed : message.transitionSpeedOverride)
                    },
                    0
                );
                return slideDuration * 1000;
            },

            setupSwiper: function () {
                console.log("setupSwiper");
                this.swiper = new Swiper($('.swiper-container'), {
                    loop: this.pages > 1,
                    effect: getTransitionName(this.noticeBoard.transition),
                    fadeEffect: {
                        crossfade: true
                    },
                    autoplay: {
                        delay: this.noticeBoard.transitionSpeed * 1000,
                        disableOnInteraction: false
                    },
                });

                this.swiper.on('slideChange', this.swiperSlideChange);
                //var slideTime = this.slideMessagesDuration(1);
                //window.setTimeout(this.swiperSlideNext, slideTime);


                this.checkMessagesTextSize();
                console.log("setupSwiper - finished");
                //$(".swiper-slide").css("background-color", $("#home-wrapper").css("background-color"))
            },


            swiperSlideChange(swiper) {
                var page = this.swiper.activeIndex;
                console.log(page);
                if (page > this.pages)
                    page = 1;

                var messages = this.slideMessages(page);

                if (messages.length > 1)
                    return;


                var currentMessage = messages[0];
                console.log(page + " " + (currentMessage ? currentMessage.noticeMessageId : "no message"))
                if(currentMessage)
                    this.$emit("message-changed", currentMessage);
            },
            //swiperSlideNext() {
            //    this.swiper.slideNext();
            //},



            forceRerender: function () {
                this.show = false;
                this.$nextTick(function () {
                    this.show = true;
                    this.setupSwiper();
                });
            },
            setTextSize: function () {
                //this.$parent.autosizeText();
                setTimeout(this.checkMessagesTextSize, 0);                               
            },
            checkMessagesTextSize: function () {
                console.log("checkMessagesTextSize");

                if (this.checkTextSize() && this.pages < this.messages.length) {
                    this.pages = this.pages + 1;

                }
                console.log("checkMessagesTextSize - finished");
            },
            checkTextSize: function () {
                var tooSmall = false;

                $(".non-sticky-wrapper").find(".resize").each(function () {
                    var portrait = window.screen.height > window.screen.width;
                    var width = window.screen.width;
                    var isFhd = width > 1900 || portrait && width > 1000
                    var minWidth = isFhd ? 45 : 40;
                    if ($(this).css("font-size").replace("px", "") < minWidth) {
                        console.log($(this).css("font-size").replace("px", "") + " - " + $(this).html());
                        tooSmall = true;
                        return false;
                    }
                });


                return tooSmall;
            }
            
        },
        props: {
            messages: {
            },
            noticeBoard: {
                type: Object
            },
            stickyHeight: {

            }

        },
        computed: {
            fullScreenStretch: function () {
                return !this.noticeBoard.displayBBCTickerTape &&
                    !this.noticeBoard.displayLiveClock &&
                    !this.noticeBoard.footer &&
                    this.noticeBoard.pictures.length == 0;
            }
        },
        watch: {
            messages: {
                handler: function () {
                    this.pages = this.noticeBoard.transition == 0 ? 1 : this.messages.length;
                    this.forceRerender();
                },
                deep: true
            },
            stickyHeight: function () {
                this.forceRerender();
            },
            pages: function () {
                console.log(this.pages)
                this.forceRerender();
            },
            noticeBoard: {
                handler: function () {
                    try {
                        this.swiper.destroy();

                    } catch (err) { }
                    this.setupSwiper();
                    this.forceRerender();
                },
                deep: true
            }
        },
        created() {
            this.show = true;
            this.pages = this.noticeBoard.transition == 0 ? 1 : this.messages.length;
            console.log("non sticky created");
        },
        mounted() {
            console.log("non sticky mounted");
            this.setupSwiper();

        },
        updated() {
            console.log("non sticky updated");
            try {
                this.swiper.destroy();
               
            } catch (err) { }
            this.setupSwiper();


        }
    }


    function getTransitionName(id) {
        switch (id) {
            case 0: return "none";
            case 1: return "swipe";
            case 2: return "fade";
            case 3: return "coverflow";
            case 4: return "flip";
            case 5: return "cube";
            default: return "";
        }
    }
</script>
<style>
    .non-sticky-wrapper {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }

        


    .swiper-container {
        height: 100%;
        /*margin-left: 7rem;
        margin-right: 7rem;*/
    }


    .swiper-slide {
    }

    .swiper-slide.non-stretch {
        padding-left: 7rem;
        padding-right: 7rem;
    }

    .swiper-slide:not(.swiper-slide-active) {
        opacity: 0 !important;
    }

        .swiper-slide-active {
            opacity: 1 !important;
        }

    
</style>

